<template>
    <div>
        <el-row :gutter="20">
            <h2 style="margin-top:unset;">UPLOAD excel</h2>
            <el-col :span="12" :offset="6">
                <el-card shadow="never" style="padding-bottom:20px;">
                    <el-row>
                        <el-col :span="16">
                            <el-upload
                                class="upload-demo"
                                action="''"
                                :auto-upload="false"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :before-remove="beforeRemove"
                                :on-exceed="handleExceedExcel"
                                multiple

                                :on-change="onUploadRateCard"
                                :file-list="fileList">
                                <el-button size="small" type="primary">Click to upload</el-button>
                            </el-upload>
                        </el-col>
                        <el-col :span="6">
                            <el-button type="success" @click="onSave">ยืนยัน</el-button>
                        </el-col>
                    </el-row>

                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import xlsx from 'xlsx'
import mixinExcel from '@/mixins/exportExcel.js'
export default {
    name: 'SortingCodeSCG',
    mixins: [mixinExcel],
    data () {
        return {
            // shopCode: '',
            sheetsName: ['Sheet1', 'Sheet2', 'Sheet3'],
            rateParam: [],
            fileList: []
        }
    },
    created () {
    },
    methods: {
        handlePreview (file) {
            console.log(file)
        },
        handleRemove (file, fileList) {
            this.rateParam = []
            this.fileList = []
            console.log(file, fileList)
        },
        beforeRemove (file, fileList) {
            return this.$confirm(`Cancel the transfert of ${file.name} ?`)
        },
        handleExceedExcel (files, fileList) {
            this.$notify.error({
                title: 'ผิดพลาด',
                message: 'กรุณาอัพโหลดทีละ 100 ไฟล์',
                duration: 6000
            })
            console.log(files, fileList)
        },
        onUploadRateCard (e) {
            console.log(e)
            this.fileName = e.name
            let files = e.name
            let f = files
            // this.uploadFile = files
            let parts = f.split('.')
            let ext = parts[parts.length - 1]
            if (ext !== 'xlsx') {
                this.$swal({
                    title: 'ผิดพลาด !',
                    text: 'ไฟล์ที่ต้องการอัพโหลดไม่ถูกต้อง',
                    type: 'error'
                })
                return
            }
            let reader = new FileReader()
            let wightRate = {}
            let param = {}
            reader.onload = async (e) => {
                // this.$loading()
                let data = e.target.result
                var workbook = xlsx.read(data, { type: 'binary' })
                // this.rateParam = {}

                this.sheetsName.forEach(e => {
                    let sheet = workbook.Sheets[e]
                    let keyRateCard = ['MIN', 'MAX', 'BKK', 'RPC']
                    let readData = xlsx.utils.sheet_to_json(sheet, { header: keyRateCard })
                    let dataWithoutKey = readData.slice(2, readData.length)
                    wightRate[readData[0].MIN.toLowerCase()] = []
                    dataWithoutKey.forEach((row, rowIdx) => {
                        wightRate[readData[0].MIN.toLowerCase()].push({
                            min: parseFloat(row.MIN.toFixed(2)),
                            max: parseFloat(row.MAX.toFixed(2)),
                            rate_bkk: parseFloat(row.BKK.toFixed(2)),
                            rate_upc: parseFloat(row.RPC.toFixed(2))
                        })
                    })
                })
                console.log(wightRate)
                param = {
                    weightRate: { ...wightRate },
                    shopCode: parts[0]
                }
                this.rateParam.push({ ...param })
                console.log(this.rateParam)
            }

            reader.readAsBinaryString(e.raw)
        },
        async onSave () {
            // console.log(this.shopCode)
            console.log(this.rateParam)

            for await (let param of this.rateParam) {
                let res = await fgApi.user.updateExcelWeightRate(param)
                console.log(res)
            }
        }
    }
}
</script>
